export default function SVG_Stroke() {
  return (
    <div>
      <h1>SVG_Stroke Component</h1>
    </div>
  );
}
